import { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Text,
  Link,
  List,
  ListItem,
  Flex,
  Grid,
  GridItem,
} from "@chakra-ui/react";

function TermsModal() {
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="full">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Bepalings en Voorwaardes/ Terms and Conditions</ModalHeader>
        <ModalBody minW={"1000px"} overflowY={"auto"}>
          <Grid>
            <GridItem colStart={1}>
            <Text mb={3} fontWeight="bold">
               Baie welkom by ons aanlynportaal vir oordbesprekings. Lees asseblief die bepalings en voorwaardes noukeurig en klik op die “Ek aanvaar”-skakel om voort te gaan.
              </Text>
            </GridItem>
            <GridItem colStart={2}>
            <Text mb={3} fontWeight="bold" >
                Welcome to our online portal for resort reservations.
Please read the terms and conditions carefully and click on the “I agree” link to continue.
              </Text>
            </GridItem>
          </Grid>
              
          <Flex direction={"row"}>
            
            <Flex flex="1" pr={4}>

              <List spacing={3} mb={4}>
                <ListItem>
                  Deur van hierdie aanlynbesprekingsportaal gebruik te maak,
                  bevestig jy dat jy jou verbind tot die volgende reëls, en
                  indien die reëls oortree word, sal jou bespreking gekanselleer
                  word, sal inbetaling volgens die nie-ledetarief moet geskied
                  en kan jou lidmaatskapstatus heroorweeg word.
                </ListItem>
                <ListItem>
                  Lede mag 3 eenhede of kampeerstaanplekke teen die lidtarief
                  bespreek. Neem kennis dat die voordeel slegs opgeneem kan word
                  waar die eenhede almal deel vorm van een bespreking, en kan
                  dus nie opgeneem word as 2 of 3 aparte besprekings nie. Indien
                  4 of meer eenhede verlang word, kan die eerste 3 eenhede deur
                  hierdie portaal bespreek word, en enige addisionele eenhede
                  deur www.atkvoorde.co.za/bespreek. Onderhewig aan
                  beskikbaarheid. Inbelbesprekings kwalifiseer nie vir die
                  hierdie aanbod nie. Aankoms- en vertrekdatum moet voor 28
                  Februarie 2025 wees.
                </ListItem>
                <List as="ul" styleType="disc" pl={5}>
                  <ListItem>
                    Laag-/Buiteseisoenmidweek (Sondag tot Donderdag): 'n Lid kan
                    drie verblyfeenhede of kampeerstaanplekke in totaal
                    bespreek.
                  </ListItem>
                  <ListItem>
                    Laag/Buiteseisoennaweek (Vrydag en Saterdag): ŉ Lid kan drie
                    verblyfeenhede of kampeerstaanplekke in totaal bespreek.
                  </ListItem>
                  <ListItem>
                    Middel/Skouer/Langnaweekseisoen: ŉ Lid kan twee
                    verblyfeenhede of kampeerstaanplekke in totaal bespreek.
                  </ListItem>
                  <ListItem>
                    Hoog/Spitsseisoen: ŉ Lid kan slegs een verblyfeenheid of
                    kampeerstaanplek bespreek.
                  </ListItem>
                </List>
                <ListItem>
                  Lede mag onder geen omstandighede die internetskakel (URL) met
                  nie-lede deel nie. Nie-lede wat die skakel gebruik om ŉ
                  bespreking te maak, sal die volle jaarlikse ledegeld of die
                  verskil tussen die lede- en nie-ledetarief moet inbetaal.
                </ListItem>
                <ListItem>
                  Ledetariewe geld slegs vir besprekings wat direk per telefoon,
                  e-pos of deur ons aanlyn besprekingsportaal deur die ATKV
                  hanteer word, en nie vir besprekings wat deur
                  derdepartybesprekingsagente gedoen word nie.
                </ListItem>
                <ListItem>
                  Die lid waaronder die bespreking gemaak is, moet tydens
                  aankoms teenwoordig wees met hul ID/paspoort as bewys. Die lid
                  moet ook vir die volle duur van die bespreekte verblyf op die
                  oord teenwoordig wees.
                </ListItem>
                <ListItem>
                  Die standaard oordbepalings en -voorwaardes geld steeds, sowel
                  as die aanlynbesprekingsvoorwaardes wat hier beskikbaar is:{" "}
                  <Link
                    href="https://www.atkvoorde.co.za/bepalings-en-voorwaardes/"
                    isExternal
                    color="blue.500"
                  >
                    https://www.atkvoorde.co.za/bepalings-en-voorwaardes/
                  </Link>
                </ListItem>
              </List>
            </Flex>

            <Flex flex="1" pl={4}>

              <List spacing={3}>
                <ListItem>
                  By using this online booking portal, you confirm that you will
                  abide by the following rules and if the rules are broken, your
                  booking will be cancelled, payment will have to be made
                  according to the non-member rate and your membership status
                  may be reconsidered.
                </ListItem>
                <ListItem>
                  Members may book 3 units or camp stands at the member rate.
                  Please note that this benefit can only be used where the units
                  form part of a single booking, and cannot be broken up as 2 or
                  3 individual bookings. If 4 or more units are required, the
                  first 3 units may be reserved through this portal, and any
                  additional units through www.atkvresorts.co.za/book. Subject
                  to availability. Phone-in bookings do not qualify for this
                  offer. Arrival and departure dates must be before 28 February
                  2025.
                </ListItem>
                <List as="ul" styleType="disc" pl={5}>
                  <ListItem>
                    Low season/Out of season midweek (Sunday to Thursday): A
                    member can book three accommodation units or camping stands
                    in total.
                  </ListItem>
                  <ListItem>
                    Low season/Out of season weekend (Friday and Saturday): A
                    member can book three accommodation units or camping stands
                    in total.
                  </ListItem>
                  <ListItem>
                    Middle/Shoulder/Long weekend season: A member can book two
                    accommodation units or camping stands in total.
                  </ListItem>
                  <ListItem>
                    High/Peak season: A member can book only one accommodation
                    unit or camping stand.
                  </ListItem>
                </List>
                <ListItem>
                  Members are not allowed to share the web link (URL) with
                  non-members. Non-members who use the link to make a booking
                  will have to pay the full membership fee or the difference
                  between the member and non-member rate.
                </ListItem>
                <ListItem>
                  Members' tariffs also only applies to bookings that were
                  handled by the ATKV directly via telephone, email or via our
                  online portal, and not to bookings made via third-party
                  booking agents.
                </ListItem>
                <ListItem>
                  A member under whom the booking is made must be present on
                  arrival with their ID/passport as proof. The member must also
                  be present on the resort for the full duration of the booked
                  stay.
                </ListItem>
                <ListItem>
                  The standard resort terms and conditions still apply, as well
                  as the online booking conditions available here:{" "}
                  <Link
                    href="https://www.atkvoorde.co.za/bepalings-en-voorwaardes/"
                    isExternal
                    color="blue.500"
                  >
                    https://www.atkvoorde.co.za/bepalings-en-voorwaardes/
                  </Link>
                </ListItem>
              </List>
            </Flex>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" onClick={handleClose}>
            Ek Stem Saam/ I Agree
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default TermsModal;
